import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import ShipmentWaybillService from "@/services/shipment.service";
import _ from "underscore";
import mappers from "@/helpers/mappers";
import RoutePlugin from "@/plugins/route.plugin";

export default {
    data() {
        return {
            loading: false,
            shipments: [],
            shipmentsTotalCount: 0,
            filters: {},

            queryParamDateFormat: 'YYYY-MM-DD',
            defaultValue: {
                sort: null,
                desc: null,
                page: null,
                limit: null,
                start: null,
                end: null,
                branch: null,
                search: null,
                isCustomerApproved: null,
                isExecutorApproved: null,
                isDeclined: null,
                hasInvoice: null,
                status: null,
                statuses:[]
            },
        }
    },

    methods: {
        loadShipments(options, filters) {
            this.loading = true
            this.$store.dispatch(LAYOUT_LOADING_START)

            const {sortBy, sortDesc, page, itemsPerPage} = options;
            const {start, end, branch, search, isCustomerApproved, isExecutorApproved, isDeclined, hasInvoice, status, statuses} = filters;
            const skip = (page - 1) * itemsPerPage;


            ShipmentWaybillService.getAllbox({
                ...{
                    sortBy: sortBy.length === 1 ? sortBy[0] : null,
                    sortDesc: sortDesc.length === 1 ? sortDesc[0] : null,
                    skip: skip <= 0 ? null : skip,
                    limit: itemsPerPage <= 0 ? null : itemsPerPage,
                    branch: branch,
                    start: start,
                    end: end,
                    isExecutorApproved: isExecutorApproved,
                    isCustomerApproved: isCustomerApproved,
                    isDeclined: isDeclined,
                    hasInvoice: hasInvoice,
                    q: search,
                    status: status,
                    statuses:statuses.join().replace(/,/g, " ")
                }, ...this.filters
            })
                .then(response => {
                    this.shipmentsTotalCount = response.data.Total
                    this.shipments = _.map(response.data.Records, shipment => {
                        return mappers.mapShipment(shipment)
                    })
                })
                .finally(() => {
                    this.loading = false
                    this.$store.dispatch(LAYOUT_LOADING_STOP)
                })
        },

        onUpdate(options, filters) {
            const {sortBy, sortDesc, page, itemsPerPage} = options;
            const {start, end, branch, search, isCustomerApproved, isExecutorApproved, isDeclined, hasInvoice, status, statuses} = filters;

            const queryParams = {
                sort: sortBy,
                desc: sortDesc,
                page: page,
                limit: itemsPerPage,
                start: start ? start.format(this.queryParamDateFormat) : null,
                end: end ? end.format(this.queryParamDateFormat) : null,
                branch: branch,
                search: search,
                isCustomerApproved: isCustomerApproved,
                isExecutorApproved: isExecutorApproved,
                isDeclined: isDeclined,
                hasInvoice: hasInvoice,
                status: status,
                statuses:statuses
            }
            this.$router.replace({name: this.$route.name, query: queryParams}).catch(() => {
            })

            this.loadShipments(options, filters)
        },
        onPrint(shipmentId) {
            ShipmentWaybillService.printPdf(shipmentId);
        },
        onExcelSingleDownload(shipmentId) {
            ShipmentWaybillService.downloadExcelSingle(shipmentId)
        },
        onExcelAllDownload(options, filters) {
            const {sortBy, sortDesc} = options;
            const {start, end, branch, search, isCustomerApproved, isExecutorApproved, status} = filters;

            ShipmentWaybillService.downloadExcelAll({
                ...{
                    sortBy: sortBy.length === 1 ? sortBy[0] : null,
                    sortDesc: sortDesc.length === 1 ? sortDesc[0] : null,
                    branch: branch,
                    start: start,
                    end: end,
                    isExecutorApproved: isExecutorApproved,
                    isCustomerApproved: isCustomerApproved,
                    q: search,
                    status: status
                }, ...this.filters
            })
        }
    },

    created() {
        // init query params
        try {
            const {sort, desc, page, limit} = this.$route.query;
            const {start, end, branch, search, isCustomerApproved, isExecutorApproved, isDeclined, hasInvoice, status, statuses} = this.$route.query;

            this.defaultValue.page = RoutePlugin.getNumber(page)
            this.defaultValue.limit = RoutePlugin.getNumber(limit)
            this.defaultValue.sort = RoutePlugin.getString(sort)
            this.defaultValue.desc = RoutePlugin.getBoolean(desc)
            this.defaultValue.start = RoutePlugin.getMoment(start, this.queryParamDateFormat)
            this.defaultValue.end = RoutePlugin.getMoment(end, this.queryParamDateFormat)
            this.defaultValue.branch = RoutePlugin.getNumber(branch)
            this.defaultValue.search = RoutePlugin.getString(search)
            this.defaultValue.isCustomerApproved = RoutePlugin.getBoolean(isCustomerApproved)
            this.defaultValue.isExecutorApproved = RoutePlugin.getBoolean(isExecutorApproved)
            this.defaultValue.isDeclined = RoutePlugin.getBoolean(isDeclined)
            this.defaultValue.hasInvoice = RoutePlugin.getBoolean(hasInvoice)
            this.defaultValue.status = RoutePlugin.getNumber(status)
            this.defaultValue.statuses = RoutePlugin.getArrayInt(statuses, " ")
        } catch (exception) {
            window.console.log(exception)
        }
    }
}